










































import { Vue, Component, Prop } from "vue-property-decorator";
import loginInfo from "@/general/store/modules/loginInfo";
import Button from "@/common/components/atoms/Button.vue";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import meta from "@/general/store/modules/meta";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    Button,
    IconAlert
  }
})
export default class ErrorSession extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) error!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;

  get redirectUrl() {
    // 戻り先 url の設定が必要
    return (
      process.env.VUE_APP_AUTH_FACADE +
      "?callback_authorization_start_uri=" +
      process.env.VUE_APP_API_DOMAIN +
      "/v1/top/auth-start"
    );
  }
  get title() {
    const metaTitle = process.env.VUE_APP_PAGE_TITLE;
    return metaTitle;
  }

  get currentHref() {
    return window.location.href;
  }
  async created() {
    // SSOログアウト判定フラグ trueの場合はSSOエラー画面用の文言を表示する。
    this.ssoFlg = loginInfo.isSso;
  }

  async mounted() {
    console.log("mouted");
    if (!this.ssoFlg) {
      await meta.setDocumentTitle("セッションタイムアウトになりました。");
    }

    LocalStorage.removeAll();
    AuthApi.getLogout();
    auth.remove();
    /*
    const login_facade =
      process.env.VUE_APP_AUTH_FACADE +
      "?callback_authorization_start_uri=" +
      process.env.VUE_APP_API_DOMAIN +
      "/v1/top/auth-start";
    window.location.href = login_facade;
    */

    // document Titleの設定
    // this.$meta.setDocumentTitle("セッションタイムアウトになりました。");
    // this.$page.isBreadcrumb = false;
    // this.$page.isPageHeader = false;
    // this.$page.isPageTop = false;
    // this.$page.isSubHeader = true;
    // this.$page.showFooterMenu = false;
    // Remove logic authenticationLevel
    // if(this.$route.query.authenticationLevel != 1){
    //   this.logout();
    // }
  }
}
